import { activity_CANCEL_REPORT, activity_SET_REPORT_EVENT } from '../actions/activity'
import { common_CLEAR_DATA } from '../actions/common'
import type { TReduxAction } from '../actions'
import type { Type_ICalendarEvent } from '../../../zap/Type/Type.hive'

export type TActivityState = {
    reportEvent: Type_ICalendarEvent
}

const initialState: TActivityState = {
    reportEvent: null,
}

export function activityReducer(state: TActivityState = initialState, action: TReduxAction): TActivityState {
    switch (action.type) {
        case activity_SET_REPORT_EVENT:
            return {
                ...state,
                reportEvent: action.event,
            }
        case activity_CANCEL_REPORT:
            return initialState
        case common_CLEAR_DATA:
            return initialState
        default:
            return state
    }
}

export const getReportEvent = (state: TActivityState) => state.reportEvent

export const getReportEventId = (state: TActivityState): string | number | null => {
    const event = state.reportEvent
    return event ? event.id : null
}

export const getReportEventCampaignId = (state: TActivityState): number | null => {
    const event = state.reportEvent
    return event ? event.campaign : null
}
